import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';
import * as idpActions from '../actions';

export const FETCH_STUDY_PLAN_COURSES_REQUEST = 'FETCH_STUDY_PLAN_COURSES_REQUEST';
export const FETCH_STUDY_PLAN_COURSES_SUCCESS = 'FETCH_STUDY_PLAN_COURSES_SUCCESS';
export const FETCH_STUDY_PLAN_COURSES_FAILURE = 'FETCH_STUDY_PLAN_COURSES_FAILURE';
export const FETCH_STUDY_PLAN_REQUEST = 'FETCH_STUDY_PLAN_REQUEST';
export const FETCH_STUDY_PLAN_SUCCESS = 'FETCH_STUDY_PLAN_SUCCESS';
export const FETCH_STUDY_PLAN_FAILURE = 'FETCH_STUDY_PLAN_FAILURE';
export const PUBLISH_STUDY_PLAN_REQUEST = 'PUBLISH_STUDY_PLAN_REQUEST';
export const PUBLISH_STUDY_PLAN_SUCCESS = 'PUBLISH_STUDY_PLAN_SUCCESS';
export const PUBLISH_STUDY_PLAN_FAILURE = 'PUBLISH_STUDY_PLAN_FAILURE';

const buildFetchStudyPlanCourseUrl = (idpId) => buildUrl(`/student-idps/${idpId}/study-plan-courses`);
const buildPublishStudyPlanUrl = (idpId) => buildUrl(`/student-idps/${idpId}/study-plan`);
const buildFetchStudyPlanUrl = (idpId) => buildUrl(`/student-idps/${idpId}/study-plan`);

export function fetchStudyPlanCourseIfNeeded(idpId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchStudyPlanCourseUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchStudyPlanCourse(idpId));
  };
}

export function fetchStudyPlanIfNeeded(idpId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchStudyPlanUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchStudentPlan(idpId));
  };
}

export function fetchStudyPlanCourse(idpId) {
  return (dispatch) => {
    const url = buildFetchStudyPlanCourseUrl(idpId);
    const method = 'GET';

    return dispatch(fetchStudyPlanCourseRequest()).payload
      .then((response) => dispatch(fetchStudyPlanCourseSuccess(response)))
      .catch((error) => dispatch(fetchStudyPlanCourseFailure(error)));

    function fetchStudyPlanCourseRequest() {
      return ApiCall.createAction({
        type: FETCH_STUDY_PLAN_COURSES_REQUEST,
        payload: fetch(url),
        url,
        method,
        idpId,
      });
    }

    function fetchStudyPlanCourseSuccess(courses) {
      return ApiCall.createAction({
        type: FETCH_STUDY_PLAN_COURSES_SUCCESS,
        payload: courses,
        url,
        method,
        idpId,
      });
    }

    function fetchStudyPlanCourseFailure(error) {
      return ApiCall.createAction({
        type: FETCH_STUDY_PLAN_COURSES_FAILURE,
        error,
        url,
        method,
        idpId,
      });
    }
  };
}

export function fetchStudentPlan(idpId) {
  return (dispatch) => {
    const url = buildFetchStudyPlanUrl(idpId);
    const method = 'GET';

    return dispatch(fetchStudentPlanRequest()).payload
      .then((response) => dispatch(fetchStudentPlanSuccess(response)))
      .catch((error) => dispatch(fetchStudentPlanFailure(error)));

    function fetchStudentPlanRequest() {
      return ApiCall.createAction({
        type: FETCH_STUDY_PLAN_REQUEST,
        payload: fetch(url),
        url,
        method,
        idpId,
      });
    }

    function fetchStudentPlanSuccess(studyPlan) {
      return ApiCall.createAction({
        type: FETCH_STUDY_PLAN_SUCCESS,
        payload: studyPlan,
        url,
        method,
        idpId,
      });
    }

    function fetchStudentPlanFailure(error) {
      return ApiCall.createAction({
        type: FETCH_STUDY_PLAN_FAILURE,
        error,
        url,
        method,
        idpId,
      });
    }
  };
}

export function publishStudyPlan(idpId, studyPlan, groupIdpId) {
  return (dispatch) => {
    const url = buildPublishStudyPlanUrl(idpId);
    const method = 'POST';
    const request = fetch(url, {
      method, body: JSON.stringify(studyPlan),
    });

    return dispatch(publishStudyPlanRequest()).payload
      .then((response) => dispatch(publishStudyPlanSuccess(response)))
      .then(() => dispatch(fetchStudentPlan(idpId)))
      .catch((error) => dispatch(publishStudyPlanFailure(error)))
      .then(() => dispatch(idpActions.fetchIndividualDevelopmentPlanList(groupIdpId)));

    function publishStudyPlanRequest() {
      return ApiCall.createAction({
        type: PUBLISH_STUDY_PLAN_REQUEST,
        payload: request,
        url,
        method,
        idpId,
      });
    }

    function publishStudyPlanSuccess() {
      return ApiCall.createAction({
        type: PUBLISH_STUDY_PLAN_SUCCESS,
        url,
        method,
        studyPlan,
      });
    }

    function publishStudyPlanFailure(error) {
      return ApiCall.createAction({
        type: PUBLISH_STUDY_PLAN_FAILURE,
        error,
        url,
        method,
        idpId,
      });
    }
  };
}




// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/StudyPlan/actions.js